"use client";
import CourseCard from "./course-card";
import { useWindowSize } from "react-use";

type CatalogueOfferingsProps = {
	courses: Course[];
};

const CatalogueOfferings = ({ courses }: CatalogueOfferingsProps) => {
	const { width } = useWindowSize();

	if (width < 640) {
		return (
			<div className="grid h-fit w-full grid-cols-1 place-items-center items-stretch justify-stretch gap-2 sm:grid-cols-2 lg:grid-cols-3">
				{courses?.slice(0, 1)?.map((course: Course) => (
					<CourseCard course={course} key={course?.uuid} />
				))}
			</div>
		);
	} else if (width < 1024) {
		return (
			<div className="grid h-fit w-full grid-cols-1 place-items-center items-stretch justify-stretch gap-2 sm:grid-cols-2 lg:grid-cols-3">
				{courses?.slice(0, 2)?.map((course: Course) => (
					<CourseCard course={course} key={course?.uuid} />
				))}
			</div>
		);
	} else {
		return (
			<div className="grid h-fit w-full grid-cols-1 place-items-center items-stretch justify-stretch gap-2 sm:grid-cols-2 lg:grid-cols-3">
				{courses?.slice(0, 3)?.map((course: Course) => (
					<CourseCard course={course} key={course?.uuid} />
				))}
			</div>
		);
	}
};

export default CatalogueOfferings;
